<template>
  <svg @click='$emit("toggle")' data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 87.14 87.14">
    <path class="background" d="M43.57 86.34a42.81 42.81 0 1 0-42.8-42.8 42.8 42.8 0 0 0 42.8 42.8"/>
    <g class="cls-2" :class="{play: true, visible: paused}">
      <path  d="m61.37 43.57-28.5-17.39v34.79l28.5-17.4z"/>
    </g>
    <g class="cls-2" :class="{pause: true, visible: !paused}">
      <rect x="27.59" y="28.62" width="11.74" height="28.37"/><rect x="46.29" y="28.62" width="11.74" height="28.37"/>
    </g>
  </svg>
</template>

<style scoped>
  svg {
    max-width: 6em;
    height: 6em;
    margin-left: -0.5em;
    transition: transform 0.15s ease-out;
    cursor: pointer;
  }

  path.background {
    fill: var(--mint)
  }

  svg:hover {
    transform: scale(1.025);
  }

  svg:active {
    transform: scale(1);
  }

  g.play, g.pause {
    transition: opacity 0.15s ease-out 0s;
  }

  g.play.visible, g.pause.visible {
    transition: opacity 0.15s ease-out 0.15s;
    opacity: 1;
  }

  g.play:not(.visible), g.pause:not(.visible) {
    opacity: 0;
  }
</style>

<script>
export default {
  props: ['paused']
}
</script>
